import QuizFeedback from './QuizFeedback';

export default QuizFeedback;
